<script setup lang="ts">
import MultiSelect from 'primevue/multiselect';
import type { ITransactionType } from '~/interfaces/dto/wallet/transactions';

interface IMultiSelectProps {
  transactionTypes: ITransactionType[];
}

withDefaults(defineProps<IMultiSelectProps>(), {
  transactionTypes: null,
});

const selected = defineModel<ITransactionType[]>('selected-transaction-types');

const selectPassThrough = {
  root: 'relative flex justify-between bg-base rounded-lg stacked-border text-sm font-normal text-base-priority',
  dropDown: 'visible flex items-center justify-center pr-3',
  label:
    'placeholder:text-base-priority text-xs font-normal !bg-light-200 dark:!bg-dark-800 p-3 flex gap-2 capitalize w-full rounded-l-lg',
  overlay:
    'w-fit bg-base rounded-lg stacked-border text-sm font-normal text-base-priority overflow-y-scroll h-fit !z-[1104]',
  option:
    'flex flex-row-reverse justify-between py-2.5 pl-2.5 pr-1 border-1 stacked-border capitalize w-full',
  listContainer: 'p-0',
  list: 'p-0',
  pcChip: {
    root: 'flex items-center gap-1.5 truncate text-ellipsis capitalize py-2 px-1.5 stacked-border dark:bg-dark-600 bg-light-50 rounded-lg',
    removeIcon: 'rounded-full',
  },
  pcOptionCheckbox: {
    box: ({ context }) => {
      const baseClasses =
        'w-6 border rounded-lg dark:border-dark-600 border-light-600 flex items-center justify-center';
      return {
        class: `${baseClasses} ${context?.checked ? ' bg-primary-blue-gradient stacked-border-color' : 'dark:bg-dark-800 bg-light-400'}`,
      };
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <span class="text-base-priority text-xs capitalize">
      {{ $t('filter-by-type') }}
    </span>
    <MultiSelect
      v-model="selected"
      option-label="description"
      display="comma"
      :show-toggle-all="false"
      :options="transactionTypes"
      :placeholder="$t('all')"
      :selected-items-label="`${selected?.length === transactionTypes?.length ? $t('all') : `(${selected?.length}) ${$t('transactions-selected')}`}`"
      :max-selected-labels="1"
      :pt="selectPassThrough"
    />
  </div>
</template>
